export default __webpack_public_path__ + "static/media/accordion_arrow.28526607.svg";